// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"a40ef7b8","787":"0e029a22","964":"d364bc7a"}[chunkId] + ".chunk.js";
};